import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private apiUrl = environment.apiUrl;

  private token: string;
  constructor(private http: HttpClient, private userService: UserService) {
    this.token = this.userService.getAccessToken();
  }

  validateUser(username: string, password: string): Observable<HttpResponse<any>> {

    const body = {
      username: username,
      password: password
    };
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.token}`
    });

    const url = `${this.apiUrl}/api/Auth/ValidateUser`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }

  validateUserRedirection(UserId: string, LoginType: number): Observable<HttpResponse<any>> {
    const body = {
      UserId: UserId,
      LoginType: LoginType
    };
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.token}`
    });
    const url = `${this.apiUrl}/api/Auth/validateUserRedirection`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }
  validateUserRedirectionNew(Token: string, LoginType: number,IsRedirectToMW:any): Observable<HttpResponse<any>> {
    const body = {
      Token: Token,
      LoginType: LoginType
    };
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.token}`
    });
    const url = `${this.apiUrl}/api/Auth/validateUserRedirectionNew?IsRedirectToMW=${IsRedirectToMW}`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }

  IsDefaultPassword(UserId: number): Observable<HttpResponse<any>> {
    const body = {
      UserId: UserId
    };
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Auth/IsDefaultPassword`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }

  GetServiceProviderID(avacom_CustomerID: number): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.token}`
    });
    const url = `${this.apiUrl}/api/User/GetServiceProviderID?avacom_CustomerID=${avacom_CustomerID}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  ChangePassword(UserId: number, Password: string, Oldpassword: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/User/ChangePassword?UserId=${UserId}&Password=${encodeURIComponent(Password)}&Oldpassword=${encodeURIComponent(Oldpassword)}`;
    return this.http.post(url, {}, { headers: headers, observe: 'response' });
  }

  CaptureClientPortalPageWiseDetails(payload: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/ClientPortal/CaptureClientPortalPageWiseDetails`;
    return this.http.post(url, payload, { headers: headers, observe: 'response' });
  }
  CaptureClientPortalLoginDetail(payload: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/ClientPortal/CaptureClientPortalLoginDetail`;
    return this.http.post(url, payload, { headers: headers, observe: 'response' });
  }
}
